import React from "react";
import "./HeldFaceOverlay.css";
import { heldSubLabel } from "./faceHeld";

// "תפוס": another guest holds this head (editing it, or its character is being made). A readable watermark
// across the tile; pointer events pass through so the tile's own (disabled) click handler stays the single
// place that refuses the selection. `state` is "editing" | "processing" (sub-label בעריכה / בעיבוד).
const HeldFaceOverlay = ({ state }) => {
  const sub = heldSubLabel(state);
  return (
    <div
      className="held-face-overlay rtl"
      data-testid="held-face-overlay"
      data-held-state={state || "editing"}
      role="img"
      aria-label={`תפוס, ${sub}. לא ניתן לבחור ראש זה כרגע`}
    >
      <span className="held-face-overlay-label">תפוס</span>
      <span className="held-face-overlay-sub">{sub}</span>
    </div>
  );
};

export default HeldFaceOverlay;
